import * as Sentry from '@sentry/react';

export function initSentry(): void {
    // SSM no permite String vacío, así que el param suele venir como " " (un espacio). Tratamos
    // blanco como ausente para no llamar Sentry.init con un DSN inválido ("Invalid Sentry Dsn").
    const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();
    if (!dsn) return;

    Sentry.init({
        dsn,
        environment: import.meta.env.VITE_ENVIRONMENT,
        release: import.meta.env.VITE_APP_VERSION,
        integrations: [
            Sentry.browserTracingIntegration(),
            // Enmascarado explícito y no por default: el replay captura el DOM ante cualquier error,
            // y la pantalla de integraciones muestra una credencial en claro.
            Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 1.0,
        beforeSend(event) {
            if (event.request?.url?.includes('/activate?')) {
                event.request.url = event.request.url.split('?')[0];
            }
            if (event.exception?.values?.[0]?.type === 'SessionExpiredError') return null;
            return event;
        },
        beforeBreadcrumb(breadcrumb) {
            if (
                breadcrumb.category === 'fetch' &&
                typeof breadcrumb.data?.url === 'string' &&
                breadcrumb.data.url.includes('/activate?')
            ) {
                breadcrumb.data.url = '/activate';
            }
            return breadcrumb;
        },
    });
}

/**
 * Internal: export `beforeSend` y `beforeBreadcrumb` para testing.
 * No usar fuera de tests.
 */
export const _internals = {
    beforeSend: (event: Sentry.ErrorEvent): Sentry.ErrorEvent | null => {
        if (event.request?.url?.includes('/activate?')) {
            event.request.url = event.request.url.split('?')[0];
        }
        if (event.exception?.values?.[0]?.type === 'SessionExpiredError') return null;
        return event;
    },
    beforeBreadcrumb: (breadcrumb: Sentry.Breadcrumb): Sentry.Breadcrumb | null => {
        if (
            breadcrumb.category === 'fetch' &&
            typeof breadcrumb.data?.url === 'string' &&
            breadcrumb.data.url.includes('/activate?')
        ) {
            breadcrumb.data.url = '/activate';
        }
        return breadcrumb;
    },
};
